import * as React from 'react';
import Loader from './Loader';
import { GuideCard } from './GuideCard';
import NewGuideCard from './NewGuideCard';
import { CardList } from './CardList';
import { Guide } from '../guide';
import { ProfileContext, ProfileManager } from '../profile';
import { useRequest, getHeaders } from '../api/client';
import { Card } from './Card';

const guides = (context: ProfileManager) => {
  const [state, _] = useRequest(() => ({
    body: '{}',
    method: 'POST',
    url: '/guides',
    headers: getHeaders(context),
  }));

  return state;
};

const stats = (context: ProfileManager) => {
  const [state, _] = useRequest(() => ({
    method: 'GET',
    url: '/stats/guides',
    headers: getHeaders(context),
  }));

  return state;
};

const getStatsForGuide = (state: any, id: any) => {
  return state.find(
    (item: any) => item.guide_id.toLowerCase() === id.toLowerCase(),
  );
};

type Props = {
  children?: React.ReactNode;
};

export default (props: Props) => {
  const context = React.useContext(ProfileContext);
  const state = guides(context);
  const statsState = stats(context);

  if (state.error || statsState.error) {
    return <Card>Error: {state.error.message}</Card>;
  }

  if (!state.data || state.loading || statsState.loading) {
    return <Loader />;
  }

  return (
    <CardList className="animated fadeIn">
      {state.data.map((guide: Guide) => (
        <GuideCard
          guide={guide}
          stats={getStatsForGuide(statsState.data, guide.id)}
        />
      ))}
      <NewGuideCard profile={context.profile} />
      {props.children}
    </CardList>
  );
};
